import { Observable } from "rxjs";
import { ConsultRepository } from '../../repositories/consult.repository';
import { UseCase } from '../../base/use-case';
import { TeleconsultaInsertResponseEntity } from "../../../data/repositories/consult/entities/teleconsulta-insert-response.entity";


export class CreateTeleconsultaUseCase implements UseCase<{ id: string, id2: string, descripcion: string }, TeleconsultaInsertResponseEntity> {
    constructor(private ConsultRepository: ConsultRepository) { }
    execute(
        params: {id: string, id2: string, descripcion: string},
    ): Observable<TeleconsultaInsertResponseEntity> {
        return this.ConsultRepository.createTeleconsulta(params);
    }
}
